import CellTowerIcon from '@mui/icons-material/CellTower';
import { Box, Button, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { LiveDot } from '../../../../../../../components/playback/LiveDot';
interface Props {
  readonly isLoading: boolean;
  readonly isPlaying: boolean;
  readonly onClick: () => void;
}

export function PlayLiveBtn(p: Props) {
  const { $t } = useIntl();
  const { isPlaying, onClick, isLoading } = p;

  const tooltipContent = isPlaying
    ? $t({
        id: 'logger.streamScreen.controls.stop',
        defaultMessage: 'Detener',
      })
    : $t({
        id: 'logger.streamScreen.controls.playLive',
        defaultMessage: 'Reproducir LIVE',
      });

  return (
    <Tooltip title={isLoading ? '' : tooltipContent} placement="bottom">
      <Button
        loading={isLoading}
        onClick={onClick}
        variant={isPlaying && !isLoading ? 'contained' : 'outlined'}
        color="error"
        size="small"
      >
        {isPlaying ? (
          <Box display="flex" alignItems="center" gap={1}>
            {!isLoading && <LiveDot color="white" />}
            {$t({
              id: 'logger.streamScreen.controls.liveIndicator',
              defaultMessage: 'En directo',
            }).toUpperCase()}
          </Box>
        ) : (
          <CellTowerIcon />
        )}
      </Button>
    </Tooltip>
  );
}
